const num = (n) => Number(n).toLocaleString();

export const PARSE_STAGES = [
  { key: "queued", label: "Waiting for a free slot" },
  { key: "reading", label: "Reading the document", detail: (d) => (d.chars ? `${num(d.chars)} characters` : null) },
  { key: "redacting", label: "Removing personal data", detail: (d) => (d.removed ? `${d.removed} identifier${d.removed === 1 ? "" : "s"} removed` : null) },
  { key: "extracting", label: "Reading the profile", detail: (d) => d.model || null },
  { key: "merging", label: "Assembling the profile", detail: (d) => (d.total ? `${d.done} of ${d.total} sections back` : null) },
  { key: "checking", label: "Checking against our lists" },
  { key: "done", label: "Done" },
];

export const OCR_STAGES = [
  { key: "reading", label: "Opening the scan", detail: (d) => (d.pages ? `${d.pages} page${d.pages === 1 ? "" : "s"}` : null) },
  { key: "transcribing", label: "Reading the scan", detail: (d) => (d.total ? `page ${d.done} of ${d.total}` : null) },
  { key: "done", label: "Done" },
];

const stagesFor = (item) => (item.status === "ocring" ? OCR_STAGES : PARSE_STAGES);

export const runningLabel = (item) => {
  const stages = stagesFor(item);
  return stages.find((s) => s.key === item.stage)?.label
    || (item.status === "ocring" ? "Reading the scan" : "Working");
};

export const stageDetail = (item) => {
  const detail = stagesFor(item).find((s) => s.key === item.stage)?.detail;
  return detail ? detail(item.progress || {}) : null;
};

export const stageProgress = (item) => {
  const stages = stagesFor(item);
  const index = stages.findIndex((s) => s.key === (item.stage || stages[0].key));
  return (Math.max(0, index) / (stages.length - 1)) * 100;
};

export const errorCopy = ({ status, errorKind, error, stalled, ocrable }) => {
  if (stalled) {
    return {
      title: "This extraction stopped responding",
      detail: "The job has not reported progress for several minutes. It may have been interrupted.",
      action: "retry",
    };
  }
  if (status === "needs_ocr") {
    return ocrable
      ? {
        title: "Nothing legible in this scan",
        detail: error || "The scan was read but no text came back. A clearer copy may work.",
        action: "ocr",
      }
      : {
        title: "This CV has no text layer",
        detail: "It is a legacy .doc or a format we cannot read as an image.",
        action: "manual",
      };
  }
  if (errorKind === "permanent") {
    return {
      title: "This CV cannot be read automatically",
      detail: error || "The parser could not find a CV in this document.",
      action: "manual",
    };
  }
  return {
    title: "The extraction failed",
    detail: error || "The parsing service did not respond.",
    action: "retry",
  };
};
